// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"37dd235c","606":"1b9c9fea","750":"9aad40a3","787":"273a6708"}[chunkId] + ".chunk.js";
};